import React from 'react';
import { Card, CardBody } from 'reactstrap';
import AddressManager from 'components/modules/addresses/AddressManager';
import BankAccountManager from 'components/modules/bank_accounts/BankAccountsManager';
import ContactRelationshipManager from 'components/modules/contact_relationships/ContactRelationshipManager';
import { useContext } from 'react';
import { UserSettingsContext } from 'contexts/UserSettingsContext';
import Skeleton from 'react-loading-skeleton';

function SpeicherfuchsProfile({ openSection, setOpenSection }) {
    const { userId } = useContext(UserSettingsContext);
    if(!userId?.contact_id){
        return <Card><CardBody><Skeleton height={40} count={5} /></CardBody></Card>
    }

    return (
        <Card>
            <CardBody>
                <AddressManager
                    contactId={userId.contact_id}
                    openSection={openSection}
                    setOpenSection={setOpenSection}
                />
                <BankAccountManager
                    contactId={userId.contact_id}
                    openSection={openSection}
                    setOpenSection={setOpenSection}
                />
                <ContactRelationshipManager
                    contactId={userId.contact_id}
                    openSection={openSection}
                    setOpenSection={setOpenSection}
                    type="child"
                    translationKey="contact_relationships.types.children"
                    onlyNew={true}
                />
                <ContactRelationshipManager
                    contactId={userId.contact_id}
                    openSection={openSection}
                    setOpenSection={setOpenSection}
                    type="spouse"
                    translationKey="contact_relationships.types.spouses"
                    onlyNew={true}
                />
                <ContactRelationshipManager
                    contactId={userId.contact_id}
                    openSection={openSection}
                    setOpenSection={setOpenSection}
                    type="helper"
                    translationKey="contact_relationships.types.helpers"
                    onlyNew={false}
                />
            </CardBody>
        </Card>
    );
}

export default SpeicherfuchsProfile;
